import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledPublishModificationBatchId = Brand<number, 'ScheduledPublishModificationBatchId'>;
export const ScheduledPublishModificationBatchId = createBranded<ScheduledPublishModificationBatchId>();
